module.exports = __webpack_public_path__ + "static/media/FuturaBT-Light.98d2f973.ttf";